module.exports = __webpack_public_path__ + "img/provenance.6c8fa006.png";